import React, { useCallback } from "react";
import { Grid, IconButton, TableCell, TextField, Tooltip } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import MainNavbar from "../../../components/Navbars/MainNavbar";
import { withStyles } from "tss-react/mui";
import vestigingStyle from "../../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import { Delete, Visibility } from "@mui/icons-material";
import JamezzTableV2, { useReloadState } from "../../../components/JamezzTable/V2/JamezzTableV2";
import FormElement from "../../../components/JamezzTable/FormElement";
import Person from "@mui/icons-material/Person";
import { Link } from "react-router";
import Edit from "@mui/icons-material/Edit";
import useJTFilter from "../../../components/JamezzTable/V2/useJTFilter";
import { _post } from "../../../http";
import AreYouSureDialog from "../../../components/Dialogs/AreYouSureDialog";
import { useDialog } from "../../../licensing/utils/DialogProvider";
import VestigingFilterV2, { getVestigingFilterStateV2 } from "../../../components/VestigingFilter/VestigingFilter";
import { connect } from "react-redux";

const endPoint = "core/articleTraits";

function ArticleTraits(props) {
  const { classes } = props;
  const [openDialog] = useDialog();
  const { reloadState, updateReloadState } = useReloadState();
  const [textField, filters] = useJTFilter("apiId");

  const renderHeaderCells = useCallback(
    () => [
      { id: "id", label: "#", numeric: true, disablePadding: false, sortable: false },
      { id: "apiId", label: "apiId", numeric: false, disablePadding: false, sortable: false },
      {
        id: "name",
        label: <TranslationWrapper tDefault={"Name"} tKey={"articleTraits.name"} />,
        numeric: false,
        disablePadding: false,
        sortable: false,
      },
    ],
    []
  );

  const renderRowCells = useCallback((row, isEditable) => {
    return (
      <>
        <TableCell align={"right"} style={{ width: 100 }}>
          {row.id}
        </TableCell>
        <TableCell align={"right"} style={{ width: 200 }}>
          {row.apiId}
        </TableCell>
        <TableCell>
          <div>
            {isEditable ? (
              <FormElement endPoint={endPoint} name={"name"} row={row}>
                <TextField size={"small"} variant={"outlined"} />
              </FormElement>
            ) : null}
            {!isEditable ? row.name : null}
          </div>
        </TableCell>
      </>
    );
  }, []);

  const renderSelectionActions = useCallback((selected) => {
    return (
      <Tooltip title={<TranslationWrapper tKey={"Delete"} />}>
        <IconButton
          onClick={() => {
            openDialog({
              children: (
                <AreYouSureDialog
                  content={<TranslationWrapper tKey={"Are you sure you want to delete the selected profiles?"} />}
                  onOk={() => {
                    _post("/core/profiles/multipledelete", { ids: selected }).then(() => {
                      updateReloadState();
                    });
                  }}
                />
              ),
            });
          }}
          style={{ color: "lightcoral" }}
        >
          <Delete />
        </IconButton>
      </Tooltip>
    );
  }, []);

  const renderRowActions = useCallback((row) => {
    return (
      <TableCell align={"right"}>
        {row.user_id != null ? (
          <Link to={`./${row.id}/edit`}>
            <Tooltip
              classes={{ tooltip: classes.tooltip }}
              placement={"bottom"}
              title={<TranslationWrapper tDefault={"Edit"} tKey={"global.jamezzTable.edit"} />}
            >
              <IconButton color={"primary"} simple size={"small"}>
                <Edit />
              </IconButton>
            </Tooltip>
          </Link>
        ) : null}
        {row.user_id == null ? (
          <Link to={`./${row.id}/edit`}>
            <Tooltip
              classes={{ tooltip: classes.tooltip }}
              placement={"bottom"}
              title={<TranslationWrapper tDefault={"View"} tKey={"global.jamezzTable.view"} />}
            >
              <IconButton color={"primary"} simple size={"small"}>
                <Visibility />
              </IconButton>
            </Tooltip>
          </Link>
        ) : null}
      </TableCell>
    );
  }, []);

  return (
    <div>
      <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Profiles"} tKey={"profiles.table.title"} />} />
      <Grid container spacing={1}>
        <Grid container item xs={12}>
          <VestigingFilterV2 useMenukaartReferences={true} />
          {textField}
        </Grid>
        <Grid item xs={12}>
          <JamezzTableV2
            checkboxSelection={true}
            defaultRowsPerPage={100}
            dense={true}
            endPoint={"core/articleTraits"}
            filters={{ ...filters, ...props.filters }}
            headerIcon={<Person />}
            reloadState={reloadState}
            renderCellsForRow={renderRowCells}
            renderHeaderCells={renderHeaderCells}
            renderRowActions={renderRowActions}
            renderSelectionActions={renderSelectionActions}
            rowIsEditable={() => false}
            rowIsSelectable={(row) => row.user_id != null}
            rowsPerPageOptions={[100]}
            tableTitle={<TranslationWrapper tDefault={"Article Traits"} tKey={"articleTraits.table.title"} />}
            uuid={"ArticleTraits-kajsdialnwedkmmas"}
          />
        </Grid>
      </Grid>
    </div>
  );
}

//REDUX
const mapStateToProps = (state) => {
  const filters = getVestigingFilterStateV2(state, true);

  return {
    filters,
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

export default connect(mapStateToProps)(withStyles(ArticleTraits, vestigingStyle));
